export const filterBookingsByType = (bookings, donationOperationType) => {
  let filteredBookings = bookings
  if (donationOperationType === 'isOutside') {
    filteredBookings = bookings.filter((booking) => booking?.bloodDonationForm?.isOutside === true)
  } else {
    filteredBookings = bookings.filter((booking) => !booking?.bloodDonationForm?.isOutside)
  }
  return filteredBookings
}
